var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "pdfview", staticStyle: { "background-color": "#AAEEDD" } },
    [
      _c("center", [
        _c(
          "table",
          {
            staticStyle: { "border-spacing": "0px 40px" },
            attrs: {
              cellspacing: "2",
              cellpadding: "2",
              width: "97%",
              bgcolor: "#ffFFFF"
            }
          },
          [
            _c("tr", [
              _c(
                "td",
                [
                  _c("center", [
                    _c("table", { attrs: { width: "100%", border: "0" } }, [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              border: "0px none",
                              "border-style": "none",
                              "vertical-align": "bottom"
                            },
                            attrs: { colspan: "2" }
                          },
                          [
                            _c(
                              "font",
                              {
                                staticStyle: {
                                  "font-size": "1.5em",
                                  "font-weight": "bold"
                                }
                              },
                              [_vm._v("履 歴 書")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "vertical-align": "bottom",
                              "border-style": "none"
                            },
                            attrs: { colspan: "2" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.nowdate,
                                    "YYYY年MM月DD日"
                                  )
                                ) +
                                "現在 "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "noborder",
                            staticStyle: {
                              width: "100px",
                              border: "none",
                              "vertical-align": "bottom",
                              padding: "2px"
                            },
                            attrs: { rowspan: "3" }
                          },
                          [
                            _c("img", {
                              staticStyle: { width: "80px" },
                              attrs: { src: _vm.val.myphoto.bindata }
                            })
                          ]
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              width: "80px",
                              "border-style": "solid none solid solid",
                              "border-width": "1px",
                              "border-color": "#333"
                            }
                          },
                          [_c("font", [_vm._v("ふりがな ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid solid none",
                              "border-width": "1px",
                              "border-color": "#333"
                            },
                            attrs: { colspan: "2" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.val.fnamekana) +
                                _vm._s(_vm.val.lnamekana) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              width: "80px",
                              "text-align": "center",
                              "border-style": "solid solid none solid",
                              "border-width": "1px",
                              "border-color": "#333"
                            }
                          },
                          [_c("font", [_vm._v("性別 ")])],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              width: "80px",
                              "border-style": "solid none solid solid",
                              "border-width": "1px",
                              "border-color": "#333"
                            }
                          },
                          [_c("font", [_vm._v("氏 名 ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid solid none",
                              "border-width": "1px",
                              "border-color": "#333"
                            },
                            attrs: { colspan: "2" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.val.fname) +
                                _vm._s(_vm.val.lname) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              width: "80px",
                              "text-align": "center",
                              "border-style": "none solid solid solid",
                              border: "1px solid #333"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.sex) + " ")]
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              width: "80px",
                              "border-style": "solid none solid solid",
                              "border-width": "1px",
                              "border-color": "#333"
                            }
                          },
                          [_c("font", [_vm._v("生年月日 ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "text-align": "right",
                              "border-style": "solid solid solid none",
                              "border-width": "1px",
                              "border-color": "#333"
                            },
                            attrs: { colspan: "3" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.val.birthdayyear +
                                    "年" +
                                    _vm.val.birthdaymonth +
                                    "月" +
                                    _vm.val.birthdayday +
                                    "日"
                                ) +
                                "生 （満" +
                                _vm._s(_vm.val.age) +
                                "歳） "
                            )
                          ]
                        )
                      ])
                    ]),
                    _c("table", { staticClass: "bordertbl" }, [
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              "border-style": "solid none solid solid"
                            }
                          },
                          [_c("font", [_vm._v("ふりがな ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid solid none"
                            },
                            attrs: { align: "left" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.val.gen.prefnamekana) +
                                _vm._s(_vm.val.gen.addresskana) +
                                _vm._s(_vm.val.gen.addresskana2) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              "border-style": "solid none solid solid"
                            }
                          },
                          [_c("font", [_vm._v("電話 ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid solid none"
                            },
                            attrs: { align: "left" }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.gen.tel) + " ")]
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid none solid"
                            },
                            attrs: { colspan: "2" }
                          },
                          [
                            _c("font", { staticClass: "normallbl" }, [
                              _vm._v("現住所 ")
                            ]),
                            _c("font", [
                              _vm._v("(〒" + _vm._s(_vm.val.gen.zipcode) + ")")
                            ])
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              "border-style": "solid solid none solid"
                            },
                            attrs: { colspan: "2" }
                          },
                          [_c("font", [_vm._v("E-mail ")])],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "none solid solid solid"
                            },
                            attrs: { colalign: "left", colspan: "2" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.val.gen.prefname) +
                                _vm._s(_vm.val.gen.address) +
                                _vm._s(_vm.val.gen.address2) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "none solid solid solid"
                            },
                            attrs: { colspan: "2" }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.gen.email) + " ")]
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              "border-style": "solid none solid solid"
                            }
                          },
                          [_c("font", [_vm._v("ふりがな ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid solid none"
                            },
                            attrs: { align: "left" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.val.renraku.prefnamekana) +
                                _vm._s(_vm.val.renraku.addresskana) +
                                _vm._s(_vm.val.renraku.addresskana2) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              "border-style": "solid none solid solid"
                            }
                          },
                          [_c("font", [_vm._v("電話 ")])],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid solid none"
                            },
                            attrs: { align: "left" }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.renraku.tel) + " ")]
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "solid solid none solid"
                            },
                            attrs: { colspan: "2" }
                          },
                          [
                            _c("font", { staticClass: "normallbl" }, [
                              _vm._v("連絡先 ")
                            ]),
                            _c("font", [
                              _vm._v(
                                "(〒" + _vm._s(_vm.val.renraku.zipcode) + ")"
                              )
                            ])
                          ],
                          1
                        ),
                        _c(
                          "td",
                          {
                            staticClass: "normallbl",
                            staticStyle: {
                              "border-style": "solid solid none solid"
                            },
                            attrs: { colspan: "2" }
                          },
                          [_c("font", [_vm._v("E-mail ")])],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "none solid solid solid"
                            },
                            attrs: { colalign: "left", colspan: "2" }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.val.renraku.prefname) +
                                _vm._s(_vm.val.renraku.address) +
                                _vm._s(_vm.val.renraku.address2) +
                                " "
                            )
                          ]
                        ),
                        _c(
                          "td",
                          {
                            staticStyle: {
                              "border-style": "none solid solid solid"
                            },
                            attrs: { colspan: "2" }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.renraku.email) + " ")]
                        )
                      ])
                    ]),
                    _c(
                      "table",
                      { staticClass: "bordertbl" },
                      [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "normallbl",
                              staticStyle: {
                                width: "100px",
                                "text-align": "center"
                              }
                            },
                            [_c("font", [_vm._v("年")])],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "normallbl",
                              staticStyle: {
                                width: "80px",
                                "text-align": "center"
                              }
                            },
                            [_c("font", [_vm._v("月")])],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "normallbl",
                              staticStyle: { "text-align": "center" }
                            },
                            [_c("font", [_vm._v("学歴・職歴")])],
                            1
                          )
                        ]),
                        _vm._l(_vm.val.gakusyokus, function(gakusyoku) {
                          return _c(
                            "tr",
                            {
                              key: gakusyoku.id,
                              staticStyle: { height: "36px" }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(gakusyoku.year))]),
                              _c("td", [_vm._v(_vm._s(gakusyoku.month))]),
                              _c("td", [_vm._v(_vm._s(gakusyoku.content))])
                            ]
                          )
                        })
                      ],
                      2
                    ),
                    _c(
                      "table",
                      { staticClass: "bordertbl" },
                      [
                        _c("tr", [
                          _c(
                            "td",
                            {
                              staticClass: "normallbl",
                              staticStyle: {
                                width: "100px",
                                "text-align": "center"
                              }
                            },
                            [_c("font", [_vm._v("年")])],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "normallbl",
                              staticStyle: {
                                width: "80px",
                                "text-align": "center"
                              }
                            },
                            [_c("font", [_vm._v("月")])],
                            1
                          ),
                          _c(
                            "td",
                            {
                              staticClass: "normallbl",
                              staticStyle: { "text-align": "center" }
                            },
                            [_c("font", [_vm._v("免許・資格")])],
                            1
                          )
                        ]),
                        _vm._l(_vm.val.menkyosikakus, function(menkyosikaku) {
                          return _c(
                            "tr",
                            {
                              key: menkyosikaku.id,
                              staticStyle: { height: "36px" }
                            },
                            [
                              _c("td", [_vm._v(_vm._s(menkyosikaku.year))]),
                              _c("td", [_vm._v(_vm._s(menkyosikaku.month))]),
                              _c("td", [_vm._v(_vm._s(menkyosikaku.content))])
                            ]
                          )
                        })
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            ])
          ]
        ),
        _c(
          "table",
          {
            staticStyle: { "border-spacing": "0px 20px" },
            attrs: {
              cellspacing: "2",
              cellpadding: "2",
              width: "97%",
              bgcolor: "#FFFFFF"
            }
          },
          [
            _c("tr", [
              _c(
                "td",
                [
                  _c("center", [
                    _c("table", { staticClass: "bordertbl" }, [
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "normallbl" },
                          [_c("font", [_vm._v("志望動機 ")])],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              height: "380px",
                              "border-style": "none solid solid solid",
                              "vertical-align": "top",
                              "white-space": "pre-line"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.sibodoki) + " ")]
                        )
                      ])
                    ]),
                    _c("table", { staticClass: "bordertbl" }, [
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "normallbl" },
                          [_c("font", [_vm._v("通勤時間 ")])],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "normallbl" },
                          [_c("font", [_vm._v("扶養家族(配偶者を除く) ")])],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "normallbl" },
                          [_c("font", [_vm._v("配偶者 ")])],
                          1
                        ),
                        _c(
                          "td",
                          { staticClass: "normallbl" },
                          [_c("font", [_vm._v("配偶者の扶養義務 ")])],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              _vm.val.tukintimehour +
                                ":" +
                                _vm.val.tukintimeminute
                            ) + " "
                          )
                        ]),
                        _c("td", [_vm._v(_vm._s(_vm.val.huyonin) + "人 ")]),
                        _c("td", [_vm._v(_vm._s(_vm.val.haigusyaumu) + " ")]),
                        _c("td", [
                          _vm._v(_vm._s(_vm.val.haigusyahuyogimu) + " ")
                        ])
                      ])
                    ]),
                    _c("table", { staticClass: "bordertbl" }, [
                      _c("tr", [
                        _c(
                          "td",
                          { staticClass: "normallbl" },
                          [
                            _c("font", [
                              _vm._v(
                                "本人希望記入欄（特に待遇・職種。勤務時間・その他についての希望などがあれば記入 "
                              )
                            ])
                          ],
                          1
                        )
                      ]),
                      _c("tr", [
                        _c(
                          "td",
                          {
                            staticStyle: {
                              height: "380px",
                              "text-align": "left",
                              "vertical-align": "top",
                              "white-space": "pre-line"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.val.honninkiboran) + " ")]
                        )
                      ])
                    ])
                  ])
                ],
                1
              )
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }